module.exports = __webpack_public_path__ + "static/gallery-12-9bc2d2eb5fd8f293cd28e210667b945a.jpg";